import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UnsubscribeService {
  private readonly url = "https://api.1artifactware.com/marketing";

  constructor(private httpClient: HttpClient) {
  }

  unsubscribe(resource: string): Observable<{}> {
    return this.httpClient.get<{}>(`${this.url}/resource/${resource}/delete`);
  }
}
